import { BookingConditions, BrokerFirm, FirmProduct, ProductTypeTypes } from '../types';

function hasPropertyThatPreventsCustomerBooking(product: FirmProduct): boolean {
    return (
        product.hasProductPropertyEditCustomerImages ||
        product.hasProductPropertyOnlyCentralBooking ||
        product.hasProductPropertySunsetPhotography
    );
}

function needsItsOwnBookingFlow(product: FirmProduct): boolean {
    return (
        product.productTypeType === ProductTypeTypes.Styling ||
        product.hasProductPropertyDuskPhotography
    );
}

export function canBeBookedInCalendar(
    brokerFirm: BrokerFirm | undefined,
    chosenProducts: FirmProduct[]
): boolean {
    if (!brokerFirm || !brokerFirm.isCustomerAllowedToBook || chosenProducts.length === 0) {
        return false;
    }

    return (
        !chosenProducts.some(hasPropertyThatPreventsCustomerBooking) &&
        !chosenProducts.some(needsItsOwnBookingFlow) &&
        !chosenProducts.some(
            (product) => product.bookingCondition.value === BookingConditions.BookableByAdmin
        ) &&
        !chosenProducts.every(
            (product) => product.bookingCondition.value === BookingConditions.NotBookable
        )
    );
}
